import { CONSTRUCTION_HOUSES_CDN_PATH } from '../../construction-houses-constants';

type ConstructionHousesAdviceStructure = {
  imageSrc: string;
  imageAlt: string;
  name: string;
  link: string;
};

export const CONSTRUCTION_HOUSES_ADVICE_DATA: ConstructionHousesAdviceStructure[] = [
  {
    imageSrc: `${CONSTRUCTION_HOUSES_CDN_PATH}/advice/dom-za-3-nedeli.jpg/dom-za-3-nedeli.jpg`,
    imageAlt: 'Готовый дачный дом',
    name: 'Дачный дом за\u00A03\u00A0недели',
    link: '/advice/stroymaterialy/dachnyy-dom-za-3-nedeli/',
  },
  {
    imageSrc: `${CONSTRUCTION_HOUSES_CDN_PATH}/advice/krovlya-iz-metallocherepicy.jpg/krovlya-iz-metallocherepicy.jpg`,
    imageAlt: 'Крыша из металлочерепицы',
    name: 'Как покрыть кровлю металлочерепи\u00ADцей',
    link: '/advice/stroymaterialy/kak-pokryt-krovlyu-metallocherepitsey/',
  },
  {
    imageSrc: `${CONSTRUCTION_HOUSES_CDN_PATH}/advice/stolbchatyj-fundament.jpg/stolbchatyj-fundament.jpg`,
    imageAlt: 'Столбчатый фундамент',
    name: 'Делаем столбчатый фундамент из\u00A0блоков',
    link: '/advice/stroymaterialy/delaem-stolbchatyy-fundament-iz-blokov/',
  },
];
